import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  NON_PARTICIPATING_BANKS_LABEL,
  PARTICIPATING_BANKS,
  ParticipatingBank
} from '../../../../core/constants/participating-banks.constants';

@Component({
  selector: 'app-banks-participants-modal',
  templateUrl: './banks-participants-modal.component.html',
  styleUrls: ['./banks-participants-modal.component.scss']
})
export class BanksParticipantsModalComponent {

  readonly banks: ReadonlyArray<ParticipatingBank> = PARTICIPATING_BANKS;
  readonly disclaimer = NON_PARTICIPATING_BANKS_LABEL;
  readonly failedLogos = new Set<string>();

  constructor(public readonly activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.dismiss();
  }

  onLogoError(bank: ParticipatingBank): void {
    this.failedLogos.add(bank.logo);
  }

  showLogo(bank: ParticipatingBank): boolean {
    return !this.failedLogos.has(bank.logo);
  }
}
